// src/auth/AuthProvider.tsx — SCE Issues
// Wrapper MsalProvider pour l'application React

import { MsalProvider } from '@azure/msal-react'
import type { ReactNode } from 'react'
import { msalInstance } from './msalConfig'

interface AuthProviderProps {
  children: ReactNode
}

/**
 * Provider d'authentification à placer au plus haut niveau de l'app.
 * Injecte le contexte MSAL dans toute la hiérarchie des composants.
 */
export function AuthProvider({ children }: AuthProviderProps): JSX.Element {
  return <MsalProvider instance={msalInstance}>{children}</MsalProvider>
}
